import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface BulkDeleteDialogData<T = Record<string, unknown>> {
    items: T[];
    entityLabel: string;
    entityLabelPlural?: string;
    displayProperty: keyof T & string;
    nameProperties?: (keyof T & string)[];
    dateProperties?: (keyof T & string)[];
    subtitle?: string;
    warningNote?: string;
    itemsLabel?: string;
}

@Component({
  standalone: false,
  selector: 'app-bulk-delete-confirmation-dialog',
  templateUrl: './bulk-delete-confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bulk-delete-confirmation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BulkDeleteConfirmationDialogComponent {
  itemCount: number = 0;
  itemDescriptions: string[] = [];
  entityLabelKey: string = '';

  constructor(
    public dialogRef: MatDialogRef<BulkDeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BulkDeleteDialogData
  ) {
    this.itemCount = data.items?.length || 0;
    this.itemDescriptions = (data.items || []).map(item => this.getItemDescription(item));
    this.entityLabelKey =
      this.itemCount === 1 ? data.entityLabel : data.entityLabelPlural ?? data.entityLabel;
  }


  public trackByIndex = trackByIndex;

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    this.dialogRef.close(true);
  }

  getItemDescription(item: Record<string, unknown>): string {
    const details: string[] = [];

    const nameProperties = this.data.nameProperties ?? [];
    const dateProperties = this.data.dateProperties ?? [];

    const name = nameProperties.find(prop => item[prop]);
    if (name && item[name]) {
      details.push(String(item[name]));
    }

    const dateField = dateProperties.find(prop => item[prop]);
    if (dateField && item[dateField]) {
      const date = new Date(item[dateField] as string | number);
      details.push(date.toISOString().split('T')[0]);
    }

    return details.length > 0 ? details.join(', ') : 'Item';
  }
}
